import { set, useFormContext } from "react-hook-form";
import Table from "../../../../../components/Tables/NonEditableTable";
import PrintToPDF from "./PrintToPDF";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { useParams } from "react-router-dom";

import {
  Button,
  MenuItem,
  Select,
  Typography,
  InputLabel,
  FormControl,
  Grid,
  Paper,
  Chip,
  OutlinedInput,
  Box as MuiBox,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";

import EstimationColumns, {
  SummaryColumns,
  NozzleEstimationColumns,
  estCols,
  trimListCols,
  pvEstCols,
  pvSumEst,
  structuralEstCols,
} from "./columns";
import { minimalMuiTableProps } from "../../../../../styles/muiProps";
import { useEffect, useState, useRef } from "react";
import AddToFabricationDialog from "./AddToFabricationDialog";
import ValidateDialog from "./ValidateDialog";
import { transformsPVEstData } from "./utils";
import DataSource from "./DataSourceRadioButtons";
import { json } from "react-router-dom";
import RevisionModal from "./RevisionSavingModal";
import NewRACIModal from "./NewRACIModal";
import SharePointIcon from "../../../../../components/CustomIcons/SharePointIcon";
import { secondAxios } from "../../../../../api/axios";
// import { columns } from "../../CommonFeatures/EstimationTab/utils";

export default function EstimationTab({
  projectId,
  plant,
  parentType,
  parentTabIndex,
}) {
  const [DGV_Main_Estimation, setDGV_Main_Estimation] = useState([]);
  const [Est_Sum_DGV, setEst_Sum_DGV] = useState([]);
  const [Fab_Rate_Txt, setFab_Rate_Txt] = useState("");
  const [Proposal_Cost_Txt, setProposal_Cost_Txt] = useState("");
  const [tableData, setTableData] = useState([]);
  const [estData, setEstData] = useState(undefined);
  const [dataSource, setDataSource] = useState("sharepoint");

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isValidateDialogOpen, setValidateDialog] = useState(false);
  const [isReviosnModalOpen, setRevisionModal] = useState(false);
  const [inputRevNum, setInpuRevNum] = useState(null);
  const { plantId } = useParams();

  // New state for project/revision selection
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [selectedRevisionId, setSelectedRevisionId] = useState("");

  const getValuesAxios = async () => {
    console.log("getting data ", parentType);

    const res = await secondAxios.get(`/plant/${plantId}`);
    const allProjects = Array.isArray(res.data.project)
      ? res.data.project
      : res.data.projects ||
        (res.data.project
          ? [res.data.project]
          : Array.isArray(res.data)
          ? res.data
          : [res.data]);
    console.log(
      "pppppp",
      process.env.REACT_APP_CLIENT_NAME,
    allProjects
    );
    const filteredProjects = allProjects.filter(
      (p) =>
        p.clientName === process.env.REACT_APP_CLIENT_NAME &&
        p.type === parentType
    );

    // Store projects for dropdown (no auto-loading)
    setProjects(filteredProjects);
    console.log("filteredProjects", filteredProjects);

    return filteredProjects[0];
  };

  const loadEstimationData = (projectList, selectedIndices) => {
    console.log("projectList", projectList);
    let combinedData = [];

    // If no projects selected, show all
    if (!Array.isArray(selectedIndices) || selectedIndices.length === 0) {
      projectList.forEach((project) => {
        const estimationData =
          project?.revisions?.[0]?.data?.estimationTable?.[0]?.Estimation;
        // console.log("estimationDataxxxx", estimationData);
        if (Array.isArray(estimationData)) {
          combinedData.push(...estimationData);
        }
      });
    } else {
      // Filter by selected project indices
      selectedIndices.forEach((idx) => {
        const project = projectList[idx];
        if (project) {
          const estimationData =
            project?.revisions?.[0]?.data?.estimationTable?.[0]?.Estimation;
          if (Array.isArray(estimationData)) {
            combinedData.push(...estimationData);
          }
        }
      });
    }
    // console.log("combinedData", combinedData);
    setTableData(combinedData);
    setEstData(combinedData);
  };
  let fhGetValues;
  try {
    const ctx = useFormContext();
    fhGetValues = ctx?.getValues ?? (() => ({}));
  } catch (e) {
    // No form context available (e.g. when `plant` is true) — provide a safe fallback
    fhGetValues = () => ({});
  }
  const getValues = plant ? getValuesAxios : fhGetValues;

  const printRef = useRef();

  // const { DGV_Main_Estimation, Est_Sum_DGV, Fab_Rate_Txt, Proposal_Cost_Txt } =
  //   getValues();

  const [assembly, setAssembly] = useState([]); // Changed to array for multi-select
  const [rev, setRev] = useState("");
  const [projects, setProjects] = useState([]);

  // Get available revisions for selected project
  const getAvailableRevisions = () => {
    if (!selectedProjectId || !projects.length) return [];
    const project = projects.find((p) => p.id === selectedProjectId);
    return project?.revisions || [];
  };

  // Check if data from selected project/revision is already in the table
  const isDataAlreadyAdded = () => {
    if (!selectedProjectId || !selectedRevisionId || !tableData.length)
      return false;
    return tableData.some(
      (row) =>
        row._projectId === selectedProjectId &&
        row._revisionId === selectedRevisionId
    );
  };

  // Handle adding selected project/revision data to table
  const handleAddEstimationData = () => {
    if (!selectedProjectId || !selectedRevisionId || !projects.length) return;

    const project = projects.find((p) => p.id === selectedProjectId);
    if (!project) return;

    const revision = project.revisions?.find(
      (r) => r.id === selectedRevisionId
    );
    if (!revision?.data?.estimationTable) return;

    // estimationTable is an object with numeric string keys like "0", "1"
    // Get the first available key or use "0" as default
    const estimationTable = revision.data.estimationTable;
    if (!estimationTable || typeof estimationTable !== "object") return;

    const keys = Object.keys(estimationTable);
    if (keys.length === 0) return;

    const firstKey = keys[0];
    const estimationData = estimationTable[firstKey]?.Estimation;

    if (Array.isArray(estimationData) && estimationData.length > 0) {
      // Add metadata to track which project/revision this data came from
      const dataWithMetadata = estimationData.map((row) => ({
        ...row,
        _projectId: selectedProjectId,
        _revisionId: selectedRevisionId,
      }));

      // Append the new data to existing table data
      setTableData((prevData) => [...prevData, ...dataWithMetadata]);
      setEstData((prevData) => {
        const newData = prevData
          ? [...prevData, ...dataWithMetadata]
          : [...dataWithMetadata];
        return newData;
      });
      // Reset selection after adding
      setSelectedProjectId("");
      setSelectedRevisionId("");
    }
  };

  // Handle removing selected project/revision data from table
  const handleRemoveEstimationData = () => {
    if (!selectedProjectId || !selectedRevisionId) return;

    // Filter out rows that match the selected project/revision
    setTableData((prevData) =>
      prevData.filter(
        (row) =>
          !(
            row._projectId === selectedProjectId &&
            row._revisionId === selectedRevisionId
          )
      )
    );
    setEstData((prevData) =>
      prevData
        ? prevData.filter(
            (row) =>
              !(
                row._projectId === selectedProjectId &&
                row._revisionId === selectedRevisionId
              )
          )
        : []
    );
    // Reset selection after removing
    setSelectedProjectId("");
    setSelectedRevisionId("");
  };

  const revsData = plant
    ? []
    : getValues().revisions
    ? getValues().revisions.map((r) => r.data)
    : "";

  // 'Est.' Cant be used as accessorkey, hence renamed.
  const reformatSummaryTable = Est_Sum_DGV?.map((elem) => ({
    ...elem,
    estimated: elem["Est."],
  }));

  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setValidateDialog(false);
    setIsDialogOpen(false);
  };
  const handleAssemblyChange = (e) => {
    setAssembly(e.target.value);
  };
  const handleRevChange = (e) => {
    // console.log("revision value", e.target.value);
    // setRev(e.target.value);
  };
  // useEffect(() => {
  //   const setEstData = () => {
  //     // console.log("revision", revsData[rev]);
  //     const data = revsData[rev];
  //     console.log(data);
  //     if (data) {
  //       setDGV_Main_Estimation(data.DGV_Main_Estimation);
  //       setEst_Sum_DGV(data.Est_Sum_DGV);
  //       setFab_Rate_Txt(data.Fab_Rate_Txt);
  //       setProposal_Cost_Txt(data.Proposal_Cost_Txt);
  //     }
  //   };
  //   setEstData();
  // }, [rev, revsData]);
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    // console.log("hhhhhhhhhhhhhhhhhhh", event);
    if (!file) return;

    try {
      const fileContent = await file.text();

      const jsonData = JSON.parse(fileContent);
      // console.log("File Content:", jsonData);

      // Set the data from file
      // const transformedData = transformsPVEstData(jsonData);
      console.log(
        "Loaded Data:",
        jsonData.data.estimationTable[0].Estimation[0]
      );
      setTableData(jsonData.data.estimationTable[0].Estimation[0]);
      setEstData(jsonData.data.estimationTable[0].Estimation[0]);
    } catch (error) {
      console.error("Error reading file:", error);
    }
  };
  // Removed automatic data loading - data is now added manually via Add button
  // useEffect(() => {
  //   if (plant && projects.length > 0) {
  //     loadEstimationData(projects, assembly);
  //   }
  // }, [assembly, plant, projects]);

  useEffect(() => {
    if (plant) {
      getValues();

      return;
    }
    if (dataSource === "database") {
      const revs = getValues()?.revisions || [];
      const getData = () => {
        if (revs[0]) {
          const projData = revs[0]?.data;
          return typeof projData === "string" ? JSON.parse(projData) : projData;
        }
      };
      const data = getData();
      console.log("hereeeeexxxx", data);
      console.log(
        "hereeeee",
        data?.data?.estimationTable[0].Estimation ||
          data?.estimationTable[0].Estimation
      );
      setEstData(
        data?.data?.estimationTable[0].Estimation ||
          data?.estimationTable[0].Estimation
      );

      setTableData(
        data?.data?.estimationTable[0].Estimation ||
          data?.estimationTable[0].Estimation
      );
    }
  }, [dataSource, parentType]);
  // useEffect(() => {
  //   console.log("est data", DGV_Main_Estimation);
  // }, [isDialogOpen]);

  // console.log("dddddd", data());

  // // const manhours = [
  // //   data()?.data?.DGV_Estimation_Est[0]["Total Manhour"],
  // //   data()?.data?.DGV_Estimation_Est[1]["Total Manhour"],
  // //   data()?.data?.DGV_Estimation_Est[2]["Total Manhour"],
  // //   "",
  // //   4.9,
  // //   1.55,
  // //   4.95,
  // //   1.8,
  // //   1.55,
  // //   1.55,
  // //   1.55,
  // //   10.65,
  // // ];
  // // const weights = data()?.data?.DGV_Est_BOM.map((row) => row["Total Weight"]);
  // // const pvEstData = [
  // //   ...data()?.data?.DGV_Shell_BOM,
  // //   ...data()?.data?.DGV_Nozzle_Material_Description,
  // // ]
  // //   .map((row, i) => {
  // //     const Components = row.Description || row["Material Description"] || "";
  // //     const weight = row["Total Weight"] || "";
  // //     const cost = row["Cost (US $)"] || row["Total Cost (US $)"];

  // //     return {
  // //       ...row,
  // //       Components,
  // //       // "Total Weight (Kg)": weight,
  // //       "Total Material Cost (US $)": cost,
  // //       "Total Manhour": manhours[i],
  // //       "Total Weight (Kg)": weights[i],
  // //       Unit: row.Unit ? row.Unit : "No.",
  // //     };
  // //   })
  // //   .filter((row) => row.Components !== "Total");

  // const pvEstData = transformsPVEstData(data());
  const handlePrinting = () => {};
  return (
    <Box>
      {plant && (
        <Stack
          direction={"row"}
          padding={2}
          spacing={2}
          sx={{ alignItems: "center", flexWrap: "wrap" }}
        >
          <FilterListIcon color="secondary" />
          <Typography variant="h6" color="darkBlue">
            Add Estimation Data:
          </Typography>
          <FormControl sx={{ minWidth: 250 }}>
            <InputLabel id="project-select-label">Project</InputLabel>
            <Select
              labelId="project-select-label"
              id="project-select"
              value={selectedProjectId}
              label="Project"
              onChange={(e) => {
                setSelectedProjectId(e.target.value);
                setSelectedRevisionId(""); // Reset revision when project changes
              }}
            >
              {(projects || []).map((p) => (
                <MenuItem value={p.id} key={p.id}>
                  {p.name || p.title || `Project ${p.id}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ minWidth: 200 }}>
            <InputLabel id="revision-select-label">Revision</InputLabel>
            <Select
              labelId="revision-select-label"
              id="revision-select"
              value={selectedRevisionId}
              label="Revision"
              onChange={(e) => setSelectedRevisionId(e.target.value)}
              disabled={!selectedProjectId}
            >
              {getAvailableRevisions().map((rev) => (
                <MenuItem value={rev.id} key={rev.id}>
                  {rev.name || `Revision ${rev.id}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            color={isDataAlreadyAdded() ? "error" : "primary"}
            onClick={
              isDataAlreadyAdded()
                ? handleRemoveEstimationData
                : handleAddEstimationData
            }
            disabled={!selectedProjectId || !selectedRevisionId}
            sx={{ minWidth: 100 }}
          >
            {isDataAlreadyAdded() ? "Remove" : "Add"}
          </Button>
        </Stack>
      )}
      <Box sx={{ p: 1, width: "100%" }}>
        <Table
          // columns={EstimationColumns()}
          columns={structuralEstCols}
          // columns={estCols}
          // data={
          //   assembly == 1 && rev !== "" && DGV_Main_Estimation
          //     ? DGV_Main_Estimation
          //     : []
          // }
          // data={data()?.Estimation_DGV || []}
          data={tableData}
          additionalProps={{
            renderTopToolbarCustomActions: () =>
              !plant && (
                <Box
                  sx={{ minWidth: 500, display: "flex", alignItems: "center" }}
                >
                  <DataSource setSource={setDataSource} source={dataSource} />

                  {dataSource === "sharepoint" && (
                    <Button
                      variant="outlined"
                      component="label"
                      sx={{
                        mt: 2.5,
                        mr: 1,
                        mb: 2,
                        transform: "translateY(-2px)",
                      }}
                      startIcon={<SharePointIcon size={23} />}
                      // onClick={onSelectFromSharepoint}
                    >
                      Browse
                      <input
                        // id="upload-button"
                        type="file"
                        hidden
                        onChange={handleFileChange}
                      />
                    </Button>
                  )}

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDialogOpen}
                    sx={{ minWidth: 150, mx: 0.8 }}
                    disabled={!estData?.length}
                  >
                    Add to Fabrication
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setValidateDialog(true);
                    }}
                    sx={{ minWidth: 150, mx: 0.8 }}
                    disabled={!estData?.length}
                  >
                    Validate
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => printRef.current.generatePDF()}
                    // onClick={() => {
                    //   setRevisionModal(true);
                    // }}
                    sx={{ minWidth: 150, mx: 0.8 }}
                    disabled={!estData?.length}
                  >
                    Print to PDF
                  </Button>
                  {/* <input
                  type="file"
                  accept=".json"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                  id="file-input"
                />
                <label htmlFor="file-input">
                  <Button
                    variant="contained"
                    component="span"
                    sx={{ marginRight: 2 }}
                    disabled={dataSource !== "sharepoint"}
                  >
                    Browse
                  </Button>
                </label> */}

                  {/* <FormControl sx={{ minWidth: 200, marginRight: 1 }}>
                <InputLabel id="assembly-label">Assembly</InputLabel>
                <Select
                  labelId="assembly-label"
                  id="assembly-select"
                  value={assembly}
                  label="Assembly"
                  onChange={handleAssemblyChange}
                >
                  <MenuItem value={1}>Base Proposal</MenuItem>
                  <MenuItem value={2}>Change order1</MenuItem>
                  <MenuItem value={3}>Change order2</MenuItem>
                  {/* <MenuItem value={20}>Twenty</MenuItem>
    <MenuItem value={30}>Thirty</MenuItem> 
                </Select>
              </FormControl> */}
                  {/* <FormControl sx={{ minWidth: 200 }}>
                <InputLabel id="rev-label">Rev</InputLabel>
                <Select
                labelId="rev-label"
                  id="rev-select"
                  value={rev}
                  label="Rev"
                  onChange={handleRevChange}
                >
                  {revNums.map((r, index) => (
                    <MenuItem value={index}>{r}</MenuItem>
                  ))}
                  {/* <MenuItem value={1}>0</MenuItem>
                  <MenuItem value={2}>1</MenuItem>
                  <MenuItem value={3}>2</MenuItem> */}
                  {/* <MenuItem value={20}>Twenty</MenuItem>
    <MenuItem value={30}>Thirty</MenuItem> 
                </Select>
              </FormControl> */}
                </Box>
              ),
            initialState: {
              pagination: { pageSize: 50, pageIndex: 0 },
            },
          }}
        />
      </Box>

      {/* <Grid container sx={{ pl: 1 }}>
        <Grid Item xs={6}>
          <Box sx={{ my: 2 }}>
            <Typography
              sx={{ background: "white", py: 1, px: 2, lineHeight: 2 }}
            >
              {" "}
              Engg. and PM Percentage
              <TextField
                sx={{ "& input": { p: 0.5, width: 30 }, mx: 0.5 }}
                value={estData?.data.TextBox6}
              />{" "}
              %
            </Typography>
            <Table
              columns={pvSumEst}
              data={estData?.data.DGV_Estimation_Extra || []}
            />
          </Box>
        </Grid>
      </Grid> */}
      {/* <Grid container spacing={2}>
        <Grid item xs={6} sx={{ my: 1 }}>
          <Table
            columns={trimListCols}
            data={data()?.EstimationSummaryDescription_DGV || []}
          />
        </Grid>
        <Grid item xs={6}>
          <Paper sx={{ my: 1, borderRadius: "5px" }}>
            <Grid
              container
              sx={{
                // backgroundColor: "#fff",
                p: 5.4,
                "& > *": { p: 1, fontWeight: "bold" },
              }}
            >
              <Grid item xs={6}>
                Component Total Cost
              </Grid>
              <Grid item xs={6}>
                {data()?.txtComponentsTotalCost || ""}
                </Grid>

              <Grid item xs={6}>
                Fabrication Labour Total Cost
              </Grid>
              <Grid item xs={6}>
                {data()?.txtFabricationLabourTotalCost || ""}
              </Grid>

              <Grid item xs={6}>
                Engineering Design Total and Cost
              </Grid>
              <Grid item xs={6}>
                {data()?.txtEngineeringDesignTotalCost || ""}
              </Grid>

              <Grid item xs={6}>
                Testing and Shipping Total Cost
              </Grid>
              <Grid item xs={6}>
                {data()?.txtTestingAndShippingTotalCost || ""}
              </Grid>

              <Grid item xs={6}>
                Total Components nd Labour Cost
              </Grid>
              <Grid item xs={6}>
                {data()?.txtTotalComponentsAndLabourCost || ""}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid> */}

      {/* Add to Fabrication Dialog */}
      <AddToFabricationDialog
        open={isDialogOpen}
        onClose={handleDialogClose}
        // data={[...(tableData || [])]?.splice(0, tableData?.length - 5) || []}
        data={tableData}
      />
      <ValidateDialog
        open={isValidateDialogOpen}
        onClose={handleDialogClose}
        data={revsData || []}
      />

      {/* Summary Box */}
      {/*   <Stack direction={"row"} gap={1}>
        <Box
        sx={{ backgroundColor: "white", borderRadius: "5px" }}
          mt={5}
          width={"50%"}
          p={2}
          >
          <Stack pb={1} direction={"row"} alignItems={"center"}>
            <Typography>Fabrication Rate</Typography>
            
            <TextField
            sx={{ paddingLeft: 3, paddingRight: 3 }}
              id="fab-rate"
              value={
                assembly == 1 && rev !== "" && Fab_Rate_Txt ? Fab_Rate_Txt : ""
              }
              // label="Fabrication Rate"
              variant="outlined"
              size="small"
              contentEditable={false}
            />
            <Typography>$/hr</Typography>
          </Stack>
          <Table
            columns={SummaryColumns()}
            data={
              assembly == 1 && rev !== "" && reformatSummaryTable
                ? reformatSummaryTable
                : []
            }
            additionalProps={{
              ...minimalMuiTableProps,
              enableTopToolbar: false,
              enableBottomToolbar: false,
            }}
          />
          <Stack pt={1} direction={"row"} alignItems={"center"}>
            <Typography>Proposal Cost</Typography>

            <TextField
              sx={{ paddingLeft: 3, paddingRight: 3 }}
              id="prop-cost"
              size="small"
              value={
                assembly == 1 && Proposal_Cost_Txt ? Proposal_Cost_Txt : ""
              }
              // label="Proposal Cost"
              variant="outlined"
              contentEditable={false}
              disabled={true}
            />
            <Typography>$</Typography>
          </Stack>
        </Box> */}
      {/* <Stack
          // justifyContent={"center"}
          // alignItems={"center"}
          sx={{ backgroundColor: "white" }}
          mt={5}
          width={"50%"}
        >
          <Typography variant="h4" alignSelf={"center"}>
            Nozzle Estimation Data
          </Typography>
          <Table columns={NozzleEstimationColumns()} data={[]} />
        </Stack> 
      </Stack>*/}
      <PrintToPDF
        ref={printRef}
        header="Estimation Data"
        revNUm={inputRevNum}
        type="Estimation"
        folderPath="PV-CDT-001/2. Estimation/"
        tableComponent={
          <Table
            columns={structuralEstCols}
            data={tableData}
            additionalProps={{
              enableTopToolbar: false,
              enableBottomToolbar: false,
              enablePagination: false,
              enableColumnActions: false,
              enableSorting: false,
              enableFilters: false,
              enableFullScreenToggle: false,
              enableDensityToggle: false,
              initialState: {
                pagination: { pageSize: 50, pageIndex: 0 },
              },
            }}
          />
        }
      />
      {/* <RevisionModal
        open={isReviosnModalOpen}
        onClose={() => {
          setRevisionModal(false);
        }}
        onSubmit={(revision) => {
          setInpuRevNum(revision);
          printRef.current.generatePDF();
          console.log("Revision submitted:", revision);
        }}
      /> */}
      {/* <NewRACIModal
        open={isReviosnModalOpen}
        handleClose={() => {
          setRevisionModal(false);
        }}
        handleAddRow={(data) => {
          console.log("Data from NewRACIModal:", data);
          // Handle the data as needed
        }}
        allUsers={[]}
        type={"Estimation"}
      /> */}
    </Box>
  );
}
